export const keys = (t) => [
    {
        key: 'lifespan',
        label: t('discover.overview.shelflife.lifespan'),
        format: '0.0',
        info: 'Total number of days',
    },
    {
        key: 'activeDays',
        label: t('discover.overview.shelflife.activeDays'),
        format: '0.0',
        info: 'Only days with 50% or higher of max clicks',
    },
];
